export default {
  'blue': 'bankitalia-palette-blue',
  'pink': 'bankitalia-palette-pink',
  'green': 'bankitalia-palette-green',
  'orange': 'bankitalia-palette-orange',
  'aqua': 'bankitalia-palette-aqua'
};